import React, { useState, useEffect } from "react";
import AppBar from "../aat/components/Navigation/AppBar/AppBar";
import MobileMenu from "../aat/components/Navigation/MobileMenu/MobileMenu";
import Megadropdown from "../components/UI/Megadropdown/Megadropdown";
import CustomMegadropdown from "../aat/components/UI/Megadropdown/CustomMegadropdown";
import { connect, ConnectedProps } from "react-redux";
import { showBasketAsync, showLoginAsync } from "../store/basm/action";
import { AppThunkDispatch, AppState } from "../store";
import { getRouteItems } from "../store/route";
import { getPage } from "../store/page";
import { getPageNavColor, getPageDropdownColor, getPageNavigationProps } from "../store/page/action";
import { MenuItem } from "../typings/typings";
import styled from "styled-components";

const NavigationWrap = styled.div`
`;

const Navigation: React.FC<PropsFromRedux> = (props) =>
{
    const { page } = props;

    const [megadropdownVisible, setMegadropdownVisible] = useState(false);
    const [isDrawerVisible, setDrawerVisibility] = useState(false);
    const [currentMegadropdown, setMegadropdown] = useState(-1);
    const [navTextColor, setNavTextColor] = useState<string>("rgb(0,0,0)");

    /***
     * Set text color on mount
     */
    useEffect(() =>
    {
        if (!megadropdownVisible)
        {
            setNavTextColor(props.pageNavColor);
        }
    }, [page]);

    const getOverContent = () =>
    {
        const navProps = props.pageNavProps;
        return navProps?.navOverContent || false;
    };

    const closeMegadropdown = () =>
    {
        setMegadropdownVisible(false);
        setMegadropdown(-1);
        setNavTextColor(props.pageNavColor);
    };

    const openDrawer = () =>
    {
        setMegadropdownVisible(false);
        setNavTextColor(props.pageDropdownColor);
        setDrawerVisibility(true);
    };

    const openMegadropdown = (menuItem: MenuItem) =>
    {
        if (menuItem.children)
        {
            // Hide drawer, just in case it's visible
            setDrawerVisibility(false);
            // The order here matters, otherwise it will flash
            // 1. First set the color
            const dropdownColor = menuItem.dropdownColor || "rgb(255,255,255)";
            setNavTextColor(dropdownColor);
            // 2. Set the active dropdown id
            setMegadropdown(menuItem.id);
            // 3. Last but not least, show the dropdown
            setMegadropdownVisible(true);
        }
        else
        {
            closeMegadropdown();
        }
    };

    const closeDrawer = () =>
    {
        setDrawerVisibility(false);
        setNavTextColor(props.pageNavColor);
    };

    const handleMenuItemClick = (menuItem: MenuItem) =>
    {
        if (megadropdownVisible && menuItem.id === currentMegadropdown)
        {
            // Clicked self
            closeMegadropdown();
        }
        else
        {
            // Sesam open!
            openMegadropdown(menuItem);
        }
    };

    const burgerBtnClickHandler = () =>
    {
        if (isDrawerVisible)
        {
            closeDrawer();
        }
        else
        {
            openDrawer();
        }
    };

    const handleDropdownMenuItemClick = (menuItem: MenuItem) =>
    {
        closeMegadropdown();
    };

    const handleMobileMenuItemOnClick = (menuItem: MenuItem) =>
    {
        closeDrawer();
    };

    const handleLogoClick = () =>
    {
        closeDrawer();
        closeMegadropdown();
    };

    return (
        <NavigationWrap className={isDrawerVisible || megadropdownVisible ? "is-open" : "is-closed"}>
            <AppBar
                current={currentMegadropdown}
                menuItems={props.menuItems}
                drawer={isDrawerVisible}
                textColor={navTextColor}
                burgerButtonOnClick={burgerBtnClickHandler}
                menuItemOnClick={handleMenuItemClick}
                loginOnClick={props.showLogin}
                basketOnClick={props.showBasket}
                overContent={getOverContent()}
                logoOnClick={handleLogoClick}
                
            />

            <MobileMenu
                show={isDrawerVisible}
                menuItems={props.menuItems}
                color={navTextColor}
                setColor={setNavTextColor}
                menuItemOnClick={handleMobileMenuItemOnClick}
                closeDrawer={closeDrawer} />

            <Megadropdown
                fullscreen={true}
                visible={megadropdownVisible}>
                <CustomMegadropdown
                    id={currentMegadropdown}
                    textColor={navTextColor}
                    menuItemOnClick={handleDropdownMenuItemClick}
                    menuItems={props.menuItems} />
            </Megadropdown>
        </NavigationWrap>
    );
};


const mapStateToProps = (state: AppState) =>
{
    return {
        menuItems: getRouteItems(state.route),
        page: getPage(state.page),
        pageNavProps: getPageNavigationProps(state.page),
        pageNavColor: getPageNavColor(state.page),
        pageDropdownColor: getPageDropdownColor(state.page),
    };
};

const mapToDispatchProps = (dispatch: AppThunkDispatch) =>
    ({
        showBasket: () => dispatch(showBasketAsync()),
        showLogin: () => dispatch(showLoginAsync())
    });

const connector = connect(
    mapStateToProps,
    mapToDispatchProps
);

type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(Navigation);